var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97188 12.0261H4.10521C2.34521 12.0261 1.17188 11.1461 1.17188 9.09273V4.98607C1.17188 2.93273 2.34521 2.05273 4.10521 2.05273H9.97188C11.7319 2.05273 12.9052 2.93273 12.9052 4.98607V9.09273C12.9052 11.1461 11.7319 12.0261 9.97188 12.0261Z",
    fill: "white",
    stroke: "#92ABFE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97214 5.2793L8.13587 6.74596C7.5316 7.22703 6.54013 7.22703 5.93587 6.74596L4.10547 5.2793",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97214 5.2793L8.13587 6.74596C7.5316 7.22703 6.54013 7.22703 5.93587 6.74596L4.10547 5.2793",
    stroke: "#92ABFE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailId);
export default __webpack_public_path__ + "static/media/EmailId.b8b856a93987af3384f070c8906544d4.svg";
export { ForwardRef as ReactComponent };